// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-PG9","type":"styles_type__3rUzV","choices":"styles_choices__2Ks_W"};